<template>
<div>
    <div class="row" v-for="contenido in AgregarTipoDocuemntoARuta" :key="contenido.ContenidoDeMicrositioId">
        <div v-if="contenido.RutaDeImagen!= null" class="col-12 col-sm-5 caja " :class="columnasTexto(contenido.TamanoDeLaColumna)"  >
            <img :src="contenido.RutaDeImagen" class="imagen">
        </div>
        <div class="col-12 col-sm-7 caja" :class="columnasContenido(contenido.TamanoDeLaColumna)" >
                
            <h2 v-if="contenido.TextoDelContenido.split('|').length==2" class="titulo">{{contenido.TextoDelContenido.split("|")[0] }}</h2>
            <p id="parrafo">
                {{contenido.TextoDelContenido.split('|')[(contenido.TextoDelContenido.split('|').length)-1] }}
               
                <section class="conoce">           
                    <a v-if="contenido.AbrirEnVisor==false && contenido.TipoRuta=='DOCUMENTO'" v-on:click="AbrirArchivo(contenido.RutaArchivoCarpeta,'_self')" ><h6 class="texto-vinculos">{{contenido.TextoDelVinculo}}</h6></a>
                    <a v-else-if="contenido.AbrirEnVisor==true && contenido.TipoRuta=='DOCUMENTO'" v-on:click="AbreElVisor(contenido.RutaArchivoCarpeta)" target="_blank"><h6 class="texto-vinculos">{{contenido.TextoDelVinculo}}</h6></a>
                    <a v-else-if="contenido.TipoRuta=='RUTAEXTERNA'" :href="contenido.RutaArchivoCarpeta" target="_blank"><h6 class="texto-vinculos">{{contenido.TextoDelVinculo}}</h6></a>
                </section>
                
            </p>

        </div>
          
    </div>
    </div>
</template>

<script>
import comun from "@/../static/js/comun";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
    
    props:{
        contenidos:Array
    },
    methods:{
        columnasContenido(columnas){
            var respuesta = 'col-lg-'+(12-columnas)
            return respuesta;
        },
        columnasTexto(columnas){
            var respuesta = 'col-lg-'+(columnas)
            return respuesta;
        },
         AbreElVisor: function(vinculo) {
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
       AbrirArchivo: function(vinculo,forma) {
        comun.DescargarDocumentoPDF(vinculo);
           // comun.DescargarDocumentoPDF(vinculo)
            //window.open(vinculo,forma);
        },
    },
    
    computed:{
        AgregarTipoDocuemntoARuta:function(){
            this.contenidos.map(contenido =>{
                if(contenido.RutaDeArchivo!=null && contenido.RutaDeArchivo.includes("themisfs"))
                    contenido.TipoRuta="DOCUMENTO";
                else if(contenido.RutaDeArchivo!=null && contenido.RutaDeArchivo.includes("/Micrositio/"))
                    contenido.TipoRuta="RUTAINTERNA";
                else if(contenido.RutaDeArchivo!=null && contenido.RutaDeArchivo.includes("http"))
                    contenido.TipoRuta="RUTAEXTERNA";
                else
                    contenido.TipoRuta="NOHACERNADA";

                    return contenido;
            })
            console.log("contenido formateado::",this.contenidos)
            return this.contenidos;
        }
    }


    
}
</script>

<style scoped>

.texto-vinculos{
    font-family: 'Myriad';
    font-size: 1.4em;
    font-weight: bold;
}
.conoce{
    margin-top: 1em;
}
.caja{
    margin-top: 5em;
    }
p{
     font-family: 'AntenaBeta';
   font-size: 1.4em;
   text-align: justify;
}
.imagen
{
    border-radius: 9px;
     border-radius:2em ;
  box-shadow:  .1em .2em .9em .2em rgb(14, 13, 13);
  margin-bottom: 1em;
}
.titulo{
    font-size: 2em;
    font-weight: bold;
    
}

</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/ImagenConTextoYLink.vue